export function initNav() {
  initToggleNav()
  initScrolledNav()
}

function initToggleNav() {
  const body = document.body
  window._menuState = 0
  window._submenuState = 0

  body.addEventListener("click", (e) => {
    const el = e.target?.closest("[data-menu-toggle]")
    if (el) {
      e.preventDefault()
      _setMenuState(!window._menuState)
    }
  })

  body.addEventListener("click", (e) => {
    const containerClick = e.target?.classList?.contains("nav-container")
    if (
      containerClick &&
      window._menuState === true &&
      window._submenuState === 0
    )
      _setMenuState(0)
  })

  body.addEventListener("click", (e) => {
    const el = e.target?.closest("[data-submenu-toggle]")
    if (el) {
      e.preventDefault()
      const submenuId = el.dataset.submenuToggle
      _setSubmenuState(submenuId, el)
    }
  })

  body.addEventListener("click", (e) => {
    const el = e.target?.closest("[data-submenu-back]")
    if (el) {
      e.preventDefault()
      _setSubmenuState(0)
    }
  })

  body.addEventListener("click", (e) => {
    const el = e.target?.closest(".nav-list-item .-link")
    if (el && new URL(el.href).hash) {
      window.history.replaceState(null, null, el.href)
      window.location.reload()
    }
  })

  function _setMenuState(isOpen) {
    window._menuState = isOpen
    _setSubmenuState(0)
    body.classList.toggle("menu-is-open", isOpen)
  }

  function _setSubmenuState(targetId) {
    window._submenuState = targetId
    body.classList.toggle("submenu-is-open", targetId)
    for (const submenu of body.querySelectorAll(".nav-list--sub")) {
      submenu.previousElementSibling.classList?.toggle(
        "open",
        submenu.id === targetId,
      )
      submenu.classList.toggle("open", submenu.id === targetId)
    }
  }

  body.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      window._submenuState ? _setSubmenuState(0) : _setMenuState(0)
    }
  })
}

function initScrolledNav() {
  const handleScroll = () => {
    document.body.classList.toggle("-top", window.scrollY < 16)
  }
  handleScroll()
  window.addEventListener("scroll", handleScroll, { passive: true })
}
